import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";
import JCTemplate from "../templates/TS1_SRF_JC_TEMPLATE.docx";
import RelJCTemplate from "../templates/ReliabilityJCTemplate.docx";

function loadFile(url, callback) {
  PizZipUtils.getBinaryContent(url, callback);
}

function sanitizeForXml(value) {
  if (value == null) return "";
  return String(value).replace(
    // eslint-disable-next-line no-control-regex
    /[ --]/g,
    "",
  );
}

function sanitizeDeep(input) {
  if (input == null) return input;
  if (typeof input === "string" || typeof input === "number") return sanitizeForXml(input);
  if (Array.isArray(input)) return input.map((item) => sanitizeDeep(item));
  if (typeof input === "object")
    return Object.fromEntries(
      Object.entries(input).map(([key, value]) => [key, sanitizeDeep(value)]),
    );
  return input;
}

// Shared helper — generates the filled .docx blob from the template
const generateDocxBlob = (jobCardData) =>
  new Promise((resolve, reject) => {
    let templateDocument = "";
    if (jobCardData.jcCategory === "TS1") {
      templateDocument = JCTemplate;
    } else if (jobCardData.jcCategory === "Reliability") {
      templateDocument = RelJCTemplate;
    } else {
      reject(new Error("Unknown jcCategory: " + jobCardData.jcCategory));
      return;
    }

    loadFile(templateDocument, (error, content) => {
      if (error) { reject(error); return; }
      const zip = new PizZip(content);
      const doc = new Docxtemplater(zip, { paragraphLoop: true, linebreaks: true });
      doc.setData(sanitizeDeep(jobCardData));
      try {
        doc.render();
      } catch (err) {
        console.error("Docxtemplater render error:", err);
        reject(err);
        return;
      }
      const blob = doc.getZip().generate({
        type: "blob",
        mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      resolve(blob);
    });
  });

// Directly downloads the filled .docx (for non-admin/accounts users).
export const downloadJcWord = async (jobCardData) => {
  let blob;
  try {
    blob = await generateDocxBlob(jobCardData);
  } catch (err) {
    console.error("Error generating document:", err);
    return;
  }
  saveAs(blob, `JC_${jobCardData.jcNumber}.docx`);
};

// Opens the document in a new preview tab where the user can
// download as Word or print to PDF via the browser's native dialog.
export const openJcPreview = async (jobCardData) => {
  let blob;
  try {
    blob = await generateDocxBlob(jobCardData);
  } catch (err) {
    console.error("Error generating document:", err);
    return;
  }
  window.__jcPrintBlob = blob;
  window.__jcPrintName = `JC_${jobCardData.jcNumber}`;
  window.open("/jc-print", "_blank");
};
